import "./global";
import ModalVideoPlayer from "../classes/ModalVideoPlayer";
import ModalVideo from "../classes/ModalVideo";
import InlineVideoPlayer from "../classes/InlineVideoPlayer";
import initAlgoliaSearch from "../classes/search";
import powerUserMenu from "../classes/PowerUserMenu";
import * as Marketo from "../classes/Marketo";
import "simplebar";
import AnimatedAppearingScroll from "../classes/AnimatedAppearingScroll";
import CookieBanner from "../classes/CookieBanner";
import Analytics from "../classes/utils/Analytics";

const initVideoPopup = () => {
    document.querySelectorAll('[data-toggle="modal"]').forEach((el) => {
        new ModalVideoPlayer(el);
    });
};

const initInlineSVG = () => {
    let elements = Array.from(document.querySelectorAll(".inline-svg"));
    elements = elements.filter((el) => {
        return el.src.indexOf(".svg") > -1
    })

    if (elements.length === 0) return;

    // SVG cache to avoid duplicate requests
    const svgCache = {};

    async function fetchSVGFile(url) {
        // Return from cache if already fetched
        if (svgCache[url]) {
            // Return a clone of the cached SVG to avoid DOM conflicts
            return svgCache[url].cloneNode(true);
        }

        try {
            const response = await fetch(url);

            if (response.status !== 200) {
                console.warn(`Failed to fetch SVG from ${url}: ${response.statusText}`);
                return null;
            }

            let text = await response.text();

            // Check if the first line is an HTML doctype declaration
            if (text.startsWith("<!DOCTYPE html>")) {
                console.warn(
                    `The content fetched from ${url} appears to be an HTML document, not an SVG.`
                );
                return null;
            }

            text = text.replace(/<\?xml.*?\?>/, "").trim();

            // Parse SVG and add viewBox if missing
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, "image/svg+xml");
            const svgElement = doc.querySelector("svg");

            if (
                !svgElement.getAttribute("viewBox") &&
                svgElement.getAttribute("width") &&
                svgElement.getAttribute("height")
            ) {
                const width = svgElement.getAttribute("width");
                const height = svgElement.getAttribute("height");
                svgElement.setAttribute("viewBox", `0 0 ${width} ${height}`);
            }

            // Store in cache
            svgCache[url] = svgElement;

            // Return a clone for this specific usage
            return svgElement.cloneNode(true);
        } catch (error) {
            console.error(`Error fetching SVG from ${url}: ${error}`);
            return null;
        }
    }

    const inlineSVGFiles = async (elements) => {
        // Group elements by src to process each unique URL only once
        const elementsByUrl = {};
        elements.forEach(el => {
            const src = el.src;
            if (!elementsByUrl[src]) {
                elementsByUrl[src] = [];
            }
            elementsByUrl[src].push(el);
        });

        // Process each URL once, then apply to all matching elements
        const fetchPromises = Object.entries(elementsByUrl).map(([url, elementsForUrl]) => {
            return fetchSVGFile(url).then((svgElement) => {
                if (svgElement === null) return;

                // Replace each element with a clone of the SVG
                elementsForUrl.forEach(el => {
                    const svgClone = svgElement.cloneNode(true);
                    const fillClass = el.classList.contains("no-fill") ? "" : "fill-current";
                    svgClone.classList.add(fillClass);
                    el.parentNode.replaceChild(svgClone, el);
                });
            });
        });

        await Promise.all(fetchPromises);
    }

    inlineSVGFiles(elements)
        .then(() => console.log('SVG inlining complete'));
};


const initVideoModal = () => {
    ModalVideo.init();
    InlineVideoPlayer.init();
};

const MobileNav = () => {
    var navopener = $(".nav-opener"),
        navwrap = $(".nav-container"),
        links = navwrap.find("a:not(.back)"),
        navactive = "nav-active",
        back = $(".back");

    navopener.click(function (e) {
        e.preventDefault();
        $("body").toggleClass(navactive);
    });

    $(".nav-list li").each(function () {
        var item = $(this);
        var drop = item.find(".drop-down");
        var link = item.find("a").eq(0);
        if (drop.length) {
            item.addClass("hasdrop");
            if (link.length)
                link
                    .addClass("hasdrop-a")
                    .attr({ "data-more": "", "data-outside": "" });
        }
    });

    links.click(function () {
        $(this).hasClass("hasdrop-a") ? false : $("body").removeClass(navactive);
        $(this).closest(".nav-holder").addClass("drop-down-active");
    });

    back.click(function () {
        $(this).parents().find("a.hasdrop-a").removeClass("active");
        $(this).closest(".nav-holder").removeClass("drop-down-active");
    });

    $("html").on("click touchstart pointerdown MSPointerDown", function (e) {
        var target = $(e.target);
        if (!target.closest(navopener).length && !target.closest(navwrap).length) {
            $("body").removeClass(navactive);
            $(".drop-down-active").removeClass("drop-down-active");
        }
    });
};

const VHeight = () => {
    var Height = function () {
        const winH = window.innerHeight || document.documentElement.clientHeight;
        document.documentElement.style.setProperty("--vh", winH + "px");
        /*document.documentElement.style.setProperty(
            "--scroll-y",
            `${window.scrollY}px`
        );*/
        const winW = document.documentElement.clientWidth;
        document.documentElement.style.setProperty("--vw", winW + "px");
    };

    Height();
    // $(window).on("resize orientationChange scroll", Height);
    $(window).on("resize orientationChange", Height);
};

const goTop = () => {
    var win = $(window);

    $(".go-top").each(function () {
        var backBtn = $(this);

        win.on("load scroll", function () {
            var offset = $("#header").outerHeight();

            if (win.scrollTop() > offset) {
                backBtn.addClass("visible");
            } else {
                backBtn.removeClass("visible");
            }
        });
    });
};

document.addEventListener("DOMContentLoaded", () => {
    CookieBanner.init();
    Analytics.initPlausibleAnalytics();
    VHeight();
    MobileNav();
    initVideoPopup();
    initVideoModal();
    initInlineSVG();
    initAlgoliaSearch();
    goTop();
    new AnimatedAppearingScroll();
    new powerUserMenu();
    Marketo.initMarketo();
})
